//
//  @file EnrollOTPStep2.jsx
//  @author Sergii Oryshchenko <sergii.orishchenko@gmail.com>
//  @see https://github.com/os-v/
//
//  Created on 03.06.20.
//  Copyright 2020 Sergii Oryshchenko. All rights reserved.
//  Any usage of this material is strictly forbidden unless prior written permission is obtained from Sergii Oryshchenko <sergii.orishchenko@gmail.com>.
//

import React from "react";

import { Row, Col, FormGroup, ControlLabel } from "react-bootstrap";

import Button from "components/CustomButton/CustomButton.jsx";

import FormInputText from "components/FormInputs/FormInputText.jsx";

class EnrollOTPStep2 extends React.Component
{

    constructor(props)
    {

        super(props);

        this.state = {
        }

        this.OnCancel = this.OnCancel.bind(this);
        this.OnContinue = this.OnContinue.bind(this);

        this.ServiceRequest = null;

    }

    componentWillUnmount()
    {
        if(this.ServiceRequest)
        {
            this.ServiceRequest.abort();
            this.ServiceRequest = null;
        }
    }

    isValidated()
    {
        return true;
    }

    OnCancel()
    {
        this.props.OnResult(false);
    }

    OnContinue()
    {
        this.props.jumpToStep(2);
    }

    render()
    {
        return (
            <div className="wizard-step">
                <br/>
                <br/>
                <br/>
                <center>{global.StrPleaseFillRequiredInfo}</center>
                <br/>
                <Row>
                    <Col sm={12}>
                        <FormGroup>
                            <ControlLabel>
                                <span style={{fontSize: '14px', fontWeight: 'normal' }}>
                                    Token Data <span className="text-danger">*</span>
                                </span>
                            </ControlLabel>
                            <FormInputText
                                name="TokenData"
                                placeholder={global.StrSecretBase32}
                                defaultValue={this.props.TokenInfo.Data}
                                autoFocus
                                autoComplete="off"
                                onChange={event => this.props.TokenInfo.Data = event.target.value}
                            />
                            <center>{this.state.TextError}</center>
                        </FormGroup>
                    </Col>
                </Row>
                <br/>
                <br/>
                <center>
                    <Button fill onClick={this.OnCancel}>{global.StrCancel}</Button>&nbsp;
                    <Button fill onClick={this.OnContinue}>{global.StrContinue}</Button>
                </center>
            </div>
        );
    }

}

export default EnrollOTPStep2;
